import React from "react";
import { useNavigate, Link } from "react-router-dom";
import { TailwindToaster } from "../../../components";
import { toast } from "react-hot-toast";
import { useSelector } from "react-redux";

import axios from "../../../api/axios";

const UserAccountCreate = () => {
  const state = useSelector((state) => state.UserReducer);
  const createUrl = "/user/create/account";
  const departmentsUrl = "/department";
  const navigate = useNavigate();

  const [departmentServerData, setDepartmentServerData] = React.useState([]);
  const getDepartments = () => {
    try {
      axios
        .get(departmentsUrl, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.departments?.length > 0) {
            setDepartmentServerData(response.data.departments);
          }
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };

  const [pageTitle, setPageTitle] = React.useState("Lands & Lands ERP");
  React.useEffect(() => {
    document.title = pageTitle;
  }, [pageTitle]);
  React.useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    getDepartments();
    setPageTitle("User Accounts - L&L ERP");
  }, []);

  const [validFullName, setFullNameValidity] = React.useState(true);
  const [validEmail, setEmailValidity] = React.useState(true);
  const [validPhoneNumber, setPhoneNumberValidity] = React.useState(true);

  const handleSubmit = (event) => {
    event.preventDefault();
    var canSubmit = true;
    const enquiryData = new FormData(event.target);

    setPhoneNumberValidity(true);
    setFullNameValidity(true);
    setEmailValidity(true);

    if (enquiryData.get("newUserEmail") === "") {
      setEmailValidity(false);
      canSubmit = false;
    }
    if (enquiryData.get("fullname") === "") {
      setFullNameValidity(false);
      canSubmit = false;
    }

    if (
      enquiryData.get("phoneNumber") === "" ||
      enquiryData.get("phoneNumber").length < 10
    ) {
      setPhoneNumberValidity(false);
      canSubmit = false;
    }

    if (!canSubmit) {
      return;
    }

    const dataToSubmit = {
      fullname: enquiryData.get("fullname"),
      phoneNumber: enquiryData.get("phoneNumber"),
      newUserEmail: enquiryData.get("newUserEmail"),
      departmentId: enquiryData.get("departmentId"),
    };

    try {
      axios
        .post(createUrl, JSON.stringify(dataToSubmit), {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.status === "success") {
            toast.success(response.data.message);
            navigate(-1);
          } else {
            toast.error(response.data.message);
          }
        })
        .catch((err) => {
          toast.error(err.message);
        });
    } catch (err) {
      console.log(err);
      toast.error(err.message);
    } finally {
      //
    }
  };

  return (
    <>
      <div className='min-h-full'>
        <main className='relative'>
          <div className='max-w-7xl mx-auto py-6 sm:px-6 lg:px-8'>
            <div className='px-4 py-0 sm:px-0'>
              <div className='block'>
                <form
                  action='#'
                  method='POST'
                  noValidate
                  onSubmit={(event) => {
                    handleSubmit(event);
                  }}>
                  <TailwindToaster />
                  <div className='shadow overflow-hidden sm:rounded-md'>
                    <div className='px-4 py-5 bg-gray-50 sm:p-6'>
                      <div className='lg:flex lg:items-center justify-between'>
                        <div className='flex-1 min-w-0 px-0 lg:px-0'>
                          <h2 className='text-xl font-semibold leading-3 text-gray-dark sm:text-xl '>
                            Create Enquiry Form
                          </h2>
                        </div>
                      </div>
                      <div className='mt-4 sm:mt-4 grid grid-cols-12 gap-6'>
                        <div className='col-span-12 sm:col-span-2'>
                          <label
                            htmlFor='phoneNumber'
                            className={`block text-sm font-medium ${
                              !validPhoneNumber
                                ? "text-red-600"
                                : "text-gray-700"
                            }`}>
                            Mobile#*
                          </label>
                          <input
                            type='tel'
                            name='phoneNumber'
                            id='phoneNumber'
                            maxLength='10'
                            className={`mt-1 ${
                              !validPhoneNumber
                                ? "ring-red-800 focus:ring-red-800 border-red-800 focus:border-red-800"
                                : "focus:ring-yellow-2 focus:border-yellow-2"
                            }  block w-full shadow-sm sm:text-sm  rounded-md`}
                          />
                          {!validPhoneNumber && (
                            <p className='text-red-600 text-sm'>
                              Phone Number invalid
                            </p>
                          )}
                        </div>
                        <div className='col-span-12 sm:col-span-3'>
                          <label
                            htmlFor='fullname'
                            className={`block text-sm font-medium ${
                              !validFullName ? "text-red-600" : "text-gray-700"
                            }`}>
                            Full Name*
                          </label>
                          <input
                            type='text'
                            name='fullname'
                            id='fullname'
                            maxLength='20'
                            className={`mt-1 ${
                              !validFullName
                                ? "ring-red-600 focus:ring-red-800 border-red-800 focus:border-red-800"
                                : "focus:ring-yellow-2 focus:border-yellow-2"
                            }  block w-full shadow-sm sm:text-sm read-only:bg-gray-100 read-only:opacity-50 rounded-md`}
                          />
                          {!validFullName && (
                            <p className='text-red-600 text-sm'>
                              Full Name invalid
                            </p>
                          )}
                        </div>
                        <div className='col-span-12 sm:col-span-3'>
                          <label
                            htmlFor='newUserEmail'
                            className={`block text-sm font-medium ${
                              !validEmail ? "text-red-600" : "text-gray-700"
                            }`}>
                            Email*
                          </label>
                          <input
                            type='email'
                            name='newUserEmail'
                            id='newUserEmail'
                            maxLength='50'
                            className={`mt-1 ${
                              !validEmail
                                ? "ring-red-600 focus:ring-red-800 border-red-800 focus:border-red-800"
                                : "focus:ring-yellow-2 focus:border-yellow-2"
                            }  block w-full shadow-sm sm:text-sm read-only:bg-gray-100 read-only:opacity-50 rounded-md`}
                          />
                          {!validEmail && (
                            <p className='text-red-600 text-sm'>
                              Email invalid
                            </p>
                          )}
                        </div>
                        <div className='col-span-12 sm:col-span-3'>
                          <label
                            htmlFor='departmentId'
                            className={`block text-sm font-mediumtext-gray-700
                            }`}>
                            Department*
                          </label>
                          <select
                            id='departmentId'
                            name='departmentId'
                            className='mt-1 block w-full py-2 px-3 border  bg-white rounded-md shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-sm'>
                            {departmentServerData.length > 0 ? (
                              departmentServerData.map((item) => (
                                <option key={item?._id} value={item?._id}>
                                  {item?.name}
                                </option>
                              ))
                            ) : (
                              <option>No Departments</option>
                            )}
                          </select>
                        </div>
                      </div>

                      <div className='px-4 py-3 bg-gray-50 text-right sm:px-6'>
                        <div className='lg:flex lg:items-center justify-between'>
                          <div className='flex-1 min-w-0 px-0 lg:px-0'>
                            <Link
                              to='#'
                              onClick={(e) => {
                                e.preventDefault();
                                navigate(-1);
                              }}
                              className='inline-flex justify-center py-2 px-4 border-yellow-2 border shadow-sm text-sm font-medium rounded-sm text-yellow-2 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-2'>
                              Back
                            </Link>
                            <button
                              id='submitBtn'
                              type='submit'
                              className='ml-2 inline-flex justify-center py-2 px-4 border-transparent shadow-sm text-sm font-medium rounded-sm text-white bg-yellow-2 hover:bg-gray-dark duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-2'>
                              SAVE
                            </button>
                          </div>
                        </div>
                        <div className='sm: py-2'></div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
};

export default UserAccountCreate;
